<div class="sizes">
    <size-list
        data-test-id="size-list"
        label="Select sizes"
        type="duplicate"
        [sizes]="sizeList"
        (sizesChanged)="sizesChanged($event)"></size-list>
</div>
<div
    *ngIf="duplicateToNew"
    class="versions">
    <version-list
        data-test-id="version-list"
        [versions]="versionList"
        (versionsChanged)="versionsChanged($event)"></version-list>
</div>
<div
    class="target-list"
    [class.duplicate-to-new]="duplicateToNew">
    <div class="information-text">
        <span *ngIf="duplicateToNew">
            Please select a folder where you want your creative set to be created
        </span>
        <span *ngIf="!duplicateToNew">
            Please select a target creative set to duplicate to. Only default version will be
            duplicated.
        </span>
    </div>
    <ui-breadcrumbs
        class="breadcrumbs"
        [popoverConfig]="{ theme: 'small', panelClass: 'breadcrumb-panel' }">
        <ui-breadcrumb (click)="navigateToFolder()">
            {{ searchTerm ? 'Search results' : 'Creative sets' }}
        </ui-breadcrumb>
        <ui-breadcrumb
            *ngFor="let breadcrumb of breadcrumbs; let i = index"
            (click)="navigateToFolder(breadcrumb.id, i)">
            {{ breadcrumb.name }}
        </ui-breadcrumb>
    </ui-breadcrumbs>
    <div class="search-wrapper">
        <ui-input
            [icon]="'search'"
            [placeholder]="'Search in creative sets'"
            [(value)]="searchTerm"
            (keyup)="searchTermChanged(searchTerm)"></ui-input>
    </div>
    <ui-list
        class="creativeset-select ui-scrollbar"
        layout="list"
        [dataSource]="dataSource"
        [expandable]="false"
        [loadMoreOnScroll]="true"
        [selectionType]="'single'"
        [stickyHeader]="true"
        (selectionChange)="onSelectionChange($event)">
        <ui-list-column
            name="Name"
            property="name"
            [sortable]="false">
            <ng-template
                let-data="data"
                let-displayValue="displayValue"
                let-rowIndex="rowIndex"
                let-value="value"
                ui-list-cell-template>
                <div
                    class="list-entry"
                    [class.creativeset]="data?.type === 'Creativeset'">
                    <ng-container *ngIf="data.type === 'Folder'">
                        <ui-svg-icon
                            class="icon"
                            icon="arrow-right"></ui-svg-icon>
                        <ui-svg-icon
                            class="icon"
                            icon="folder"></ui-svg-icon>
                    </ng-container>
                    <ng-container *ngIf="data.type === 'Back'">
                        <ui-svg-icon
                            class="icon"
                            icon="arrow-left"></ui-svg-icon>
                    </ng-container>
                    <ng-container *ngIf="data.type === 'Creativeset'">
                        <ui-logo
                            class="logo icon"
                            [small]="true"></ui-logo>
                    </ng-container>
                    {{ data.name }}
                </div>
            </ng-template>
        </ui-list-column>

        <ui-list-column
            name="Modified"
            property="modified"
            width="30%"
            [sortable]="false">
            <ng-template
                let-data="data"
                let-displayValue="displayValue"
                let-rowIndex="rowIndex"
                let-value="value"
                ui-list-cell-template>
                <span title="{{ data.modified | date: 'yyyy-MM-dd hh:mm' }}">{{
                    data.modified | date: 'yyyy-MM-dd '
                }}</span>
            </ng-template>
        </ui-list-column>
    </ui-list>
    <a
        *ngIf="showLoadMore"
        class="load"
        (click)="loadMoreData()"
        >Load more creativesets</a
    >

    <ui-dialog-buttons
        class="action-buttons"
        ui-theme="default">
        <ui-button
            text="Cancel"
            type="default"
            (click)="closeDialog()"></ui-button>
        <ui-button
            [id]="duplicateToNew ? 'interaction-duplicate-to-new' : 'interaction-duplicate-to-existing'"
            type="primary"
            [disabled]="disableDuplication"
            [loading]="!!(duplicateCreativesService.isDuplicating$ | async)"
            [text]="duplicateToNew ? 'Create' : 'Duplicate'"
            (click)="duplicateCreatives()"></ui-button>
    </ui-dialog-buttons>
</div>
